import React, { useState } from 'react'
import { SocialAccountData } from '../../types/influencer/influencerTypes'
import Avatar from 'react-avatar'
import InstagramIcon from '../../assets/icons/InstagramIcon'
import { formatNumber } from '../../utils/helpers'
import { Link } from 'react-router-dom'
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants'
import InstagramLogo from '../../assets/icons/instagram-logo.svg'
import YoutubeLogo from '../../assets/icons/youtube-logo.svg'
import ArrowUpIcon from '../../assets/icons/ArrowUpIcon'
import ArrowDownIcon from '../../assets/icons/ArrowDownIcon'
import CheckIcon from '../../assets/icons/CheckIcon'
import IgConnectBenefits from '../igConnect/IgConnectBenefits'
import dummyProfilePicture from "../../assets/images/avatars/user-dummy-img.jpg"

const SocialAccountProfileCard: React.FC<{ socialAccount: SocialAccountData }> = ({ socialAccount }) => {

   

    return (
        <div className="app-card-wrapper box-shadow-none">
            <Link to={{ pathname: `/i/social-account/${socialAccount?.social_account?.uuid}` }}>
                <div className="app-sub-card box-shadow-none p-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                            <div className="social-account-profile-avatar">
                                {
                                    socialAccount.social_account.profile_picture_url ? (
                                        <img src={(socialAccount.social_account.profile_picture_url ?? '').split("=")[0]} onError={(e) => (e.target as HTMLImageElement).src = dummyProfilePicture} referrerPolicy='no-referrer' alt={socialAccount.social_account.handle} className='social-account-profile-image' />
                                    ) : (
                                        <Avatar name={socialAccount.social_account.handle} size='2.125rem' className='social-account-profile-image' />
                                    )
                                }
                                <span className='social-account-platform-icon'>
                                    {
                                        socialAccount.social_account?.platform === 'ig' && <img src={InstagramLogo as unknown as string} alt="instagram" className='social-account-platform-icon-image' />
                                    }
                                    {
                                        socialAccount.social_account?.platform === 'yt' && <img src={YoutubeLogo as unknown as string} alt="youtube" className='social-account-platform-icon-image' />
                                    }
                                </span>
                            </div>
                            <div className="d-flex flex-column gap-1">
                                <span className='fw-500 fs-16 text-dark'>@{socialAccount.social_account.handle}</span>
                                {
                                    socialAccount?.social_account?.platform === 'ig' && socialAccount.status === 'connected' &&
                                    <span className='connected-badge'>
                                        <InstagramIcon /> Connected
                                    </span>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="social-account-stats-card mt-3">
                        {
                            socialAccount?.social_account?.platform === 'ig' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{formatNumber(socialAccount?.social_account?.ig?.media_count ?? 0)}</span>
                                <span className='fs-10 text-dark fw-400'>Posts</span>
                            </div>
                        }
                        {
                            socialAccount?.social_account?.platform === 'ig' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{formatNumber(socialAccount?.social_account?.ig?.followers_count ?? 0)}</span>
                                <span className='fs-10 text-dark fw-400'>Followers</span>
                            </div>
                        }
                        {
                            socialAccount?.social_account?.platform === 'ig' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{formatNumber(socialAccount?.social_account?.ig?.follows_count ?? 0)}</span>
                                <span className='fs-10 text-dark fw-400'>Following</span>
                            </div>
                        }
                        {/* {
                            socialAccount?.social_account?.platform === 'ig' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{socialAccount?.social_account?.engagement_score}</span>
                                <span className='fs-10 text-dark fw-400'>Engagement Score</span>
                            </div>
                        } */}
                        {
                            socialAccount?.social_account?.platform === 'yt' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{formatNumber(socialAccount?.social_account?.yt?.video_count ?? 0)}</span>
                                <span className='fs-10 text-dark fw-400'>Videos</span>
                            </div>
                        }
                        {
                            socialAccount?.social_account?.platform === 'yt' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{formatNumber(socialAccount?.social_account?.yt?.subscriber_count ?? 0)}</span>
                                <span className='fs-10 text-dark fw-400'>Subscribers</span>
                            </div>
                        }
                        {
                            socialAccount?.social_account?.platform === 'yt' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{formatNumber(socialAccount?.social_account?.yt?.view_count ?? 0)}</span>
                                <span className='fs-10 text-dark fw-400'>Views</span>
                            </div>
                        }
                        {/* {
                            socialAccount?.social_account?.platform === 'yt' &&
                            <div className="d-flex flex-column align-items-center gap-1">
                                <span className='fw-500 fs-16 text-dark'>{socialAccount?.social_account?.engagement_score}</span>
                                <span className='fs-10 text-dark fw-400'>Engagement Score</span>
                            </div>
                        } */}
                    </div>
                    {
                        socialAccount?.social_account?.platform === 'ig' && socialAccount?.status !== 'connected' &&
                            <React.Fragment>
                                <div className="divider mt-1 mb-3"></div>
                                <div className="content my-0">
                                    <h4 className="fs-14 fw-600 text-dark">
                                        {['verified', 'unverified'].includes(socialAccount.status) ? 'Connect' : 'Reconnect'} your Instagram to get premium collabs.
                                    </h4>
                                    {/* <IgConnectBenefits /> */}
                                    <Link to={INIT_IG_AUTH_ROUTE + '?social_account_id=' + socialAccount.social_account.uuid} className="btn btn-sm btn-primary rounded-sm w-100 my-2 text-uppercase fs-12">Connect with Instagram</Link>
                                </div>
                        </React.Fragment>
                    }
                </div>
            </Link>
            {/* {
                socialAccount?.social_account?.platform === 'ig' && Object.values(socialAccount.permissions ?? {}).length > 0 && socialAccount.status === 'connected' &&
                <div className="d-flex flex-column gap-2 p-3 py-2">
                    <div data-bs-toggle="collapse" data-bs-target="#permissions" className="d-flex justify-content-between align-items-center cursor-pointer" onClick={() => setShowPermissions(!showPermissions)}>
                        <span className='fs-12 fw-500 text-dark'>Permissions</span>
                        <span>
                            {
                                showPermissions ? <ArrowUpIcon /> : <ArrowDownIcon />
                            }
                        </span>
                    </div>
                    <div className={`collapse ${showPermissions ? 'show' : 'hidden'}`} id="permissions">
                        <div className="d-flex flex-column">
                            {
                                Object.values(socialAccount.permissions ?? {}).map((permission, i) => <a key={i} className='d-flex align-items-center gap-2' href="#">
                                    <span><CheckIcon /></span>
                                    <span className='fs-12 fw-400 text-dark-gray'>{permission}</span>
                                </a>)
                            }
                        </div>
                        <Link className="btn btn-outline-primary w-100 rounded-4 my-2 d-flex gap-2 justify-content-center align-items-center font-14 fw-bold" to={INIT_IG_AUTH_ROUTE + '?force=y&' + 'social_account_id=' + socialAccount.social_account.uuid}><i className="fa-solid fa-rotate"></i>Refresh</Link>
                    </div>

                </div>
            } */}
        </div>
    )
}

export default SocialAccountProfileCard